import { HttpErrorResponse } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { DiffStatsService } from "../models/diff-stats.service";
import { PullRequestService } from "../models/pull-request.service";
import { DeployHelperService } from "../project-deploys/deploy-helper.service";
import { RevisionCompareUrlService } from "../revision-compare-url/revision-compare-url.service";

@Component({
  selector: "ab-deploy-view",
  templateUrl: "./deploy-view.component.html",
})
export class DeployViewComponent implements OnInit {
  @Input() public project: any;
  @Input() public deploy: any;
  @Input() public prev: any;
  @Input() public next: any;

  public timeToNextDeploy: Date;
  public timeToPrevDeploy: Date;
  public diffStats: any;
  public pullRequests: any;

  constructor(
    private deployHelperService: DeployHelperService,
    private diffStatsService: DiffStatsService,
    private pullRequestService: PullRequestService,
    private revisionCompareUrlService: RevisionCompareUrlService,
  ) {}

  public ngOnInit() {
    this.deploy.previousRevision =
      this.prev != null ? this.prev.revision : undefined;
    this.deploy.redeploy =
      this.deploy.previousRevision === this.deploy.revision;

    if (!this.deploy.repository && this.project.integrations) {
      this.deploy.linkUrl = this.revisionCompareUrlService.fromIntegration(
        this.project.integrations,
      );
    } else {
      this.deploy.linkUrl = this.revisionCompareUrlService.for(
        this.deploy.repository,
        this.deploy.previousRevision,
        this.deploy.revision,
      );
    }

    const deployAge = this.deployHelperService.calculateDeployAge(
      this.deploy,
      this.next,
    );
    const deployTime = new Date(this.deploy.createdAt).getTime();
    if (this.next) {
      this.timeToNextDeploy = new Date(
        new Date(this.next.createdAt).getTime() - deployTime,
      );
    }
    if (this.prev) {
      this.timeToPrevDeploy = new Date(
        deployTime - new Date(this.prev.createdAt).getTime(),
      );
    }

    this.deploy.deployAge = deployAge * 1000 * 60;
    this.deploy.occurrenceRate =
      this.deployHelperService.calculateOccurrenceRate(
        this.deploy.noticeTotalCount,
        deployAge,
      );

    this.fetchDiffStats();
    this.fetchPullRequests();
  }

  public trackByIndex(index: number, _item: any) {
    return index;
  }

  public pullRequestTrackBy(_index: number, pullRequest: any) {
    return pullRequest.id;
  }

  public diffStatsLineTrackBy(index: number, _line: any) {
    return index;
  }

  public rawDiffStatsLineTrackBy(index: number, _line: any) {
    return index;
  }

  private fetchDiffStats() {
    const params = {
      projectId: this.project.id,
      prevRevision: this.deploy.previousRevision,
      revision: this.deploy.revision,
    };
    this.diffStatsService.get(params).subscribe(
      (data: any) => {
        if (!data) {
          return;
        }

        this.diffStats = data;

        if (this.diffStats.raw_diff) {
          this.diffStats.raw_diff = this.diffStats.raw_diff.split("\n");
        } else {
          for (const fds of this.diffStats.file_diff_stats) {
            fds.diff = fds.diff.split("\n");
          }
        }
      },
      (error: HttpErrorResponse) => {
        // 404 is expected if there are no diff stats for this deploy
        if (error.status === 404) {
          return;
        }
      },
    );
  }

  private fetchPullRequests() {
    const params = {
      projectId: this.project.id,
      deploy_id: this.deploy.id,
    };

    this.pullRequestService.query(params).subscribe((data: any) => {
      this.pullRequests = data;
    });
  }
}
